import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import { trackPromise } from "react-promise-tracker";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faCheckDouble, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import perfilTransaccionalService from "../../../services/consultas/perfilTransaccionalService";
import history from "../login/history";
import ConfigService from "../../../services/configuracion/ConfigService";


export default class PerfilTransaccional extends Component {

  constructor(props) {
    super(props);
    this.state = {
     datos: 0,
      textoInformativo: "",
    };
  }
  componentDidMount() {
    this.getPerfilTransaccional();
  }

  getPerfilTransaccional() {
    trackPromise(
      perfilTransaccionalService.perfiles().then((response) => {
        var data = JSON.stringify(response.data['datos']);
        var jData = JSON.parse(data);
        this.setState({textoInformativo : jData});
      })
    );
  }

  volver = (e) => {
    history.push(ConfigService.getPathByName("resumenGeneralSocio")?.url);
    window.location.reload();
  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Perfil Transaccional" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                      <div className="col-md-12">
                        <p> De acuerdo a su ingreso justificado, su perfil transaccional asciende a Gs. <b>{formatoSeparadorMilesValue(this.state.textoInformativo)}</b> </p>
                      </div>
                      <div className="row col-lg-2 col-md-3 float-right"> 
                        <button
                          ref={(button) => (this.continuar = button)}
                          className="btn btn-cu-primary"
                          onClick={this.volver}
                        >
                          <FontAwesomeIcon icon={faCheckDouble} /> Entendido 
                        </button>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
